import React, { useState } from 'react';
import { PlusIcon, EditIcon, Trash2Icon } from 'lucide-react';
export function Catalogs() {
  const [activeTab, setActiveTab] = useState<'areas' | 'categories' | 'users'>('areas');
  const tabs = [{
    id: 'areas',
    label: 'Áreas / Servicios'
  }, {
    id: 'categories',
    label: 'Categorías de Prendas'
  }, {
    id: 'users',
    label: 'Usuarios y Roles'
  }] as const;
  const mockAreas = [{
    code: 'A-01',
    name: 'Emergencia',
    status: 'Activo'
  }, {
    code: 'A-02',
    name: 'Quirófano',
    status: 'Activo'
  }, {
    code: 'A-03',
    name: 'UCI',
    status: 'Activo'
  }, {
    code: 'A-04',
    name: 'Pediatría',
    status: 'Activo'
  }, {
    code: 'A-05',
    name: 'Maternidad',
    status: 'Activo'
  }, {
    code: 'A-06',
    name: 'Bodega Antigua',
    status: 'Inactivo'
  }];
  return <div className="bg-white rounded-xl shadow-sm border border-gray-200 h-full flex flex-col" data-id="element-357">
      {/* Header & Tabs */}
      <div className="border-b border-gray-200" data-id="element-358">
        <div className="p-6 flex justify-between items-center pb-0" data-id="element-359">
          <div className="flex space-x-8" data-id="element-360">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`pb-4 text-sm font-bold transition-colors relative ${activeTab === tab.id ? 'text-gray-900' : 'text-gray-500 hover:text-gray-700'}`} style={activeTab === tab.id ? {
            color: '#134073'
          } : {}} data-id="element-361">
                {tab.label}
                {activeTab === tab.id && <div className="absolute bottom-0 left-0 right-0 h-1 rounded-t-md" style={{
              backgroundColor: '#134073'
            }} data-id="element-362"></div>}
              </button>)}
          </div>
          <div className="pb-4" data-id="element-363">
            <button className="flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-bold text-white shadow-sm hover:opacity-90 transition-colors" style={{
            backgroundColor: '#3d99d2'
          }} data-id="element-364">
              <PlusIcon className="w-4 h-4" data-id="element-365" />
              Agregar Nuevo
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-auto p-6" data-id="element-366">
        {activeTab === 'areas' && <table className="w-full text-left border-collapse" data-id="element-367">
            <thead data-id="element-368">
              <tr className="bg-gray-50 text-gray-500 text-sm border-y border-gray-200" data-id="element-369">
                <th className="px-6 py-3 font-medium rounded-tl-lg" data-id="element-370">Código</th>
                <th className="px-6 py-3 font-medium" data-id="element-371">Nombre del Área</th>
                <th className="px-6 py-3 font-medium" data-id="element-372">Estado</th>
                <th className="px-6 py-3 font-medium text-right rounded-tr-lg" data-id="element-373">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody className="text-sm" data-id="element-374">
              {mockAreas.map((row, i) => <tr key={i} className="border-b border-gray-100 hover:bg-gray-50" data-id="element-375">
                  <td className="px-6 py-4 font-medium text-gray-500" data-id="element-376">
                    {row.code}
                  </td>
                  <td className="px-6 py-4 font-bold text-gray-900" data-id="element-377">
                    {row.name}
                  </td>
                  <td className="px-6 py-4" data-id="element-378">
                    <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${row.status === 'Activo' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-379">
                      {row.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-right" data-id="element-380">
                    <div className="flex justify-end gap-2" data-id="element-381">
                      <button className="p-2 rounded-lg hover:bg-blue-50 text-blue-600 transition-colors" data-id="element-382">
                        <EditIcon className="w-4 h-4" data-id="element-383" />
                      </button>
                      <button className="p-2 rounded-lg hover:bg-red-50 text-red-600 transition-colors" data-id="element-384">
                        <Trash2Icon className="w-4 h-4" data-id="element-385" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>}

        {activeTab !== 'areas' && <div className="h-64 flex items-center justify-center text-gray-400 border-2 border-dashed border-gray-200 rounded-xl" data-id="element-386">
            <p data-id="element-387">
              Contenido de la pestaña "
              {tabs.find(t => t.id === activeTab)?.label}"
            </p>
          </div>}
      </div>
    </div>;
}